import { render, staticRenderFns } from "./FishUnlockStepsComponent.vue?vue&type=template&id=32ccf1b7&"
import script from "./FishUnlockStepsComponent.vue?vue&type=script&lang=ts&"
export * from "./FishUnlockStepsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FishUnlockStepsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports